module.exports = __webpack_public_path__ + "d2ddbfdf52844b8e6fdd5a6c0869c353.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/img/banniere/banniere-developpementWeb.jpg
// module id = 157
// module chunks = 0